import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Button, Separator } from '@e2n/ui';
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Guttage() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  if (!ctx.state.showGuttageStep) return null;
  return (
    <>
      <Separator />
      <div className="my-4">
        <div className="flex items-center">
          <span className="text-neutrals-900 font-bold text-base leading-6">
            {t('domain.mitarbeiter.create.steps.abwesenheiten.guttage.title')}
          </span>
          <Button
            className="ml-auto"
            variant={'icon'}
            onClick={() => ctx.navigateToSubStep('abwesenheiten.guttage')}>
            <FontAwesomeIcon
              icon={faPenToSquare}
              className="text-primary-blue-600"
            />
          </Button>
        </div>
        <div className="py-2 grid grid-cols-2 gap-y-4 text-neutrals-800 leading-5 text-sm font-normal">
          <span>
            {t(
              'domain.mitarbeiter.create.steps.abwesenheiten.guttage.form.guttageBewerten.label',
            )}
          </span>
          <span className="text-neutrals-900 font-semibold">
            {t(
              'domain.mitarbeiter.create.steps.abwesenheiten.guttage.form.guttageBewerten.options.' +
                data.abwesenheiten.guttage.guttageBewerten,
            )}
          </span>
        </div>
      </div>
    </>
  );
}
